import React, { useContext, useEffect, useState } from 'react'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Checkbox,
} from '@mui/material'
import SnackBarContext from '../../../context/SnackBarContext'
import Excel from 'exceljs'
import moment from 'moment'

export const CostCodesGrid = (props: any) => {
  const { columns, costCodes, exportAsCSV } = props

  const sortedData = (costCodes || [])?.sort((a: any, b: any) =>
    (a.label ?? '').localeCompare(b.label ?? '')
  )

  const [checkedItems, setCheckedItems] = useState<any>({})
  const { toggleSnackbar } = useContext(SnackBarContext)

  useEffect(() => {
    ;(async () => {
      if (exportAsCSV != null && costCodes.length > 0) {
        let workbook = new Excel.Workbook()
        const workbookColumns = columns.map((column: any) => {
          return {
            header: column.headerName,
            key: column.field,
            width: column.width || 20,
          }
        })
        let worksheet = workbook.addWorksheet('Sheet')
        worksheet.columns = workbookColumns

        costCodes?.map((data: any) => {
          const obj = {
            ...columns
              .map((item: any) => ({
                [item.field]: item.valueGetter
                  ? item.valueGetter({
                      row: data,
                      value: data[item.field],
                    })
                  : data[item.field] ?? '',
              }))
              .reduce((acc: any, item: any) => {
                acc = {
                  ...acc,
                  ...item,
                }
                return acc
              }, {}),
          }
          worksheet.addRow(obj)
        })
        const buffer = await workbook.csv.writeBuffer()
        const blob = new Blob([buffer], {
          type: 'text/csv',
        })
        const fileName = `Cost Codes ${moment().format('DD.MM.YY')}`
        const file = new File([blob], fileName, {
          type: 'text/csv',
        })

        const fileURL = URL.createObjectURL(file)

        const downloadLink = document.createElement('a')
        downloadLink.href = fileURL
        downloadLink.download = `${fileName}.${'csv'}`
        document.body.appendChild(downloadLink)
        downloadLink.click()
      } else if (exportAsCSV && costCodes.length == 0) {
        toggleSnackbar('No Cost Codes available to export', 'error')
      }
    })()
  }, [exportAsCSV, costCodes, toggleSnackbar])

  return (
    <TableContainer component={Paper} sx={{ marginTop: 2, boxShadow: 'none' }}>
      <Table
        sx={{ minWidth: 650, boxShadow: 'none' }}
        aria-label='simple table'>
        <TableHead>
          <TableRow
            sx={{
              '& th': {
                backgroundColor: '#24212C',
                padding: '7px',
                color: 'white',
                fontWeight: 400,
                whiteSpace: 'nowrap',
              },
              '& th:first-child': { borderRadius: '10px 0px 0px 10px' },
              '& th:last-child': { borderRadius: '0px 10px 10px 0px' },
            }}>
            <TableCell>
              <Box
                style={{
                  flexDirection: 'row',
                  display: 'flex',
                  alignItems: 'center',
                }}>
                <Checkbox
                  checked={(sortedData || [])?.every(
                    (row: any) => checkedItems[row?._id] === true
                  )}
                  onChange={e => {
                    setCheckedItems(
                      (sortedData || []).reduce((a: any, b: any) => {
                        a[b._id] = e.target.checked
                        return a
                      }, {})
                    )
                  }}
                  sx={{ color: 'white', fill: 'white' }}
                />
                Select All
              </Box>
            </TableCell>
            {columns.map((column: any, index: number) => (
              <TableCell key={index}>{column.headerName}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        {sortedData.length > 0 ? (
          <TableBody>
            {sortedData.map((row: any, index: number) => (
              <TableRow
                key={row._id}
                sx={{
                  '&:nth-of-type(even)': {
                    backgroundColor: '#F1EFF5',
                  },
                  '&:nth-of-type(odd)': {
                    backgroundColor: 'white',
                  },
                  '& td, & th': {
                    border: 0,
                  },
                  '& td:first-child': { borderRadius: '10px 0px 0px 10px' },
                  '& td:last-child': { borderRadius: '0px 10px 10px 0px' },
                }}>
                <TableCell scope='row'>
                  <Box
                    style={{
                      flexDirection: 'row',
                      display: 'flex',
                      alignItems: 'center',
                    }}>
                    <Checkbox
                      checked={checkedItems[row?._id] === true}
                      onChange={e => {
                        setCheckedItems((prev: any) => {
                          return {
                            ...prev,
                            [row?._id]: e.target.checked,
                          }
                        })
                      }}
                      sx={{ color: '#D9D9D9', fill: 'white' }}
                    />
                  </Box>
                </TableCell>
                {columns.map((column: any, cellIndex: number) => (
                  <TableCell key={cellIndex} scope='row'>
                    {column.valueGetter
                      ? column.valueGetter({
                          row: row,
                          value: row[column.field],
                        })
                      : row[column.field] ?? ''}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        ) : (
          <TableBody>
            <TableRow>
              <TableCell colSpan={columns.length + 1} align='center'>
                No data available
              </TableCell>
            </TableRow>
          </TableBody>
        )}
      </Table>
    </TableContainer>
  )
}
